"use strict";

var _lodash = require("lodash");
var _require = require('../../lib/helpers/constants'),
  NO_IMAGE_SRC = _require.NO_IMAGE_SRC;
var getImagePath = function getImagePath(imageUri, images) {
  if (imageUri && !(0, _lodash.isEmpty)(images)) {
    return "".concat(imageUri).concat(images[0].path);
  }
  return NO_IMAGE_SRC;
};
var concatImagesAndFloorplans = function concatImagesAndFloorplans(images, floorPlans) {
  if (floorPlans && images) {
    return images.concat(floorPlans);
  }
  if (!floorPlans && images) {
    return images;
  }
  if (floorPlans && !images) {
    return floorPlans;
  }
  return [];
};
module.exports = {
  getImagePath: getImagePath,
  concatImagesAndFloorplans: concatImagesAndFloorplans
};